module.exports = __webpack_public_path__ + "assets/5ebb426b31490862846221620a154a3f.svg";